const breadcrumb = {
  add_f: 'Aggiungi nuova',
  add_m: 'Aggiungi nuovo',
  class_merch: {
    clusters: {
      index: 'Gestione cluster',
      create: 'Nuovo cluster',
      show: 'Dettagli cluster',
      edit: 'Modifica cluster',
      copy: 'Duplica cluster',
    },
  },
  order_bot: {
    compose: 'Order Bot',
    settings: 'Configurazione costi',
    create_forcing_distribution_project: 'Crea progetto forzature',
    create_forcing_distribution_project_massive: 'Carica progetti forzature',
    upload_forcing_distribution_project_entries: 'Carica forzature',
    manage_warehouse_distributions: 'Gestione perimetro teorico',
    manage_white_lists: 'Gestione forzature',
    five_thresholds_coefficients: 'Coefficienti 5 soglie',
    upload_five_thresholds_coefficients: 'Carica coefficienti 5 soglie',
    five_thresholds_constraints: 'Vincoli 5 soglie',
    economic_order_quantity: 'Parametri EOQ',
    warehouses_refilling_levels: 'Gestione livelli refilling',
    economic_order_quantity_upload: 'Carica Parametri EOQ',
    warehouses_hierarchies_classes_merchs: 'Gerarchie classi merceologiche',
    coefficients_thresholds_branch: 'Riduzione Scorte di Sicurezza',
    upload_coefficients_thresholds_branch:
      'Carica Riduzione Scorte di Sicurezza',
    phantom_orders: 'Gestione ordini phantom',
    phantom_orders_show: 'Dettaglio ordine',
    phantom_orders_upload: 'Carica ordine',
  },
  pfa_rules: {
    index: 'Premi fornitori',
    create: 'Nuovo premio',
    show: 'Dettagli premio',
    edit: 'Modifica premio',
    upload: 'Carica fatturati',
  },
  show: 'Dettaglio',
  suppliers: {
    index: 'Fornitori',
    show: 'Dettagli fornitore',
    edit: 'Modifica fornitore',
  },
  suppliers_promos: {
    index: 'Promozioni',
    create: 'Nuova promozione',
    show: 'Dettagli promozione',
    edit: 'Modifica promozione',
  },
  carbody: {
    order: 'Genera ordini',
    compare: 'Confronta Prezzi',
    upload: 'Carica Prezzi',
    index: 'Carrozzeria',
    create_new_product: 'Crea prodotti',
    updatable_products: 'Aggiorna prodotti',
    tmp_products_index: 'Nuovi prodotti',
    pending_products_index: 'Prodotti da inviare a SuperMax',
    export_suppliers: 'Fornitori esportazione',
    cars_data: 'Marche e modelli',
    manage_white_lists: 'Gestione forzature',
    catalogue_sync_new: 'Nuova sincronizzazione',
    catalogue_sync_run: 'Stato sincronizzazione',
    catalogue_sync_history: 'Storico sincronizzazioni',
    catalogue_order: 'Ordina catalogo esportazione',
  },
  products_sizes: {
    index: 'Dimensione Prodotti',
  },
  traders: {
    index: 'Componi prezzi Traders',
  },
  teccom: {
    index: 'Invia ordini',
    dispatch_advices_index: 'Bolle di consegna TecCom (DDT)',
    order_confirmations_index: "Conferme d'ordine TecCom",
  },
  update: 'Modifica',
  stock_offers: {
    index: 'Componi prezzi Stock offers',
  },
  stock_bot: {
    index: 'Stock Bot',
    panoramica: 'Panoramica',
    dettagli: 'Dettagli',
  },
  invoice_xml: {
    index: 'Fatture XML',
  },
  price_compare: {
    index: 'Confronto Prezzi',
    logs: 'Storico log',
    log_details: 'Dettagli log',
    simulate: 'Simulazione',
  },
  q_ricambi: {
    index: 'Q Ricambi',
  },
  all_cross: {
    index: 'All Cross',
  },
  cat_ia: {
    index: 'Test Cat-iA',
  },
}

export default breadcrumb
